import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/helpers/services/api.service';
import { HttpService } from 'src/app/helpers/services/http.service';
import { PublicService } from 'src/app/helpers/services/public.service';

@Component({
  selector: 'app-screenshots-list',
  templateUrl: './screenshots-list.component.html',
  styleUrls: ['./screenshots-list.component.css'],
})
export class ScreenshotsListComponent {
  public userId: number;
  public userName: string;
  screenshots: any[] = [];
  page: number = 1;
  size: number = 1000;
  totalCount: number = 0;
  totalRecords: number = 0;

  constructor(
    public activeModal: NgbActiveModal,
    public httpService: HttpService,
    private api: ApiService,
    public publicService: PublicService,
  ) {}

  ngOnInit(): void {
    this.list(1);
  }

  list(p: number): void {
    this.page = p;

    const params = {
      size: this.size,
      page: this.page,
    };

    this.httpService
      .list(
        this.api.users.getScreenshots(this.userId),
        { params },
        'screenshotsLoader',
      )
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            this.screenshots = res.data.data;
            this.totalCount = res.data.total_count;
            this.totalRecords = res.data.total_records;
          }
        },
      });
  }
}
